<template>
  <div>
    <div class="w-full pt-5">
      <div
        class="w-full h-[680px] lg:h-[600px] bg-[url('@/assets/LPnew/images/destinationbg.jpg')]"
      >
        <div class="w-full max-w-7xl mx-auto px-5">
          <div class="h-[470px] py-10">
            <div class="flex flex-col gap-1">
              <div class="title-destination">
                <h2
                  class="text-[21px] lg:text-3xl text-white bg-[#153067] font-semibold uppercase text-center px-4"
                >
                  One-Stop study<br class="md:hidden" />
                  destination
                </h2>
              </div>

              <p class="text-[18px] text-white">
                JAIN (Deemed-to-be University)
              </p>
              <div
                class="flex flex-col lg:flex-row py-2 lg:py-5 gap-5 lg:gap-5"
              >
                <div class="w-full lg:w-[50%]">
                  <img
                    src="@/assets/LPnew/images/destinationSec-img.jpg"
                    alt=""
                    class="w-full lg:h-[417px]"
                  />
                </div>

                <div
                  class="w-full lg:px-5 lg:w-[50%] flex justify-center items-center lg:h-[417px] text-[16px] lg:text-left text-white"
                >
                  Promoted by Jain Group, the university is recognized among the
                  top universities in India andconsidered a preferred
                  learner-centric destination for students from different
                  countries across the globe. Known for its emphasis on
                  education, entrepreneurship, research and sports, JAIN
                  (Deemed-to-be University) has some of the best minds in the
                  educational and research fields, and centres that inspire
                  entrepreneurship and innovative thinking.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="bg-[#212529] w-full h-[80px] md:h-[70px]">
        <div
          class="flex flex-col md:flex-row justify-center md:justify-around items-center h-[65px] gap-5 md:gap-20"
        >
          <p class="text-white text-[13px]">
            © Copyrights JAIN UNIVERSITY All Rights Reserved
          </p>
        </div>
      </footer>
    </div>
    <div class="sideNavi" id="sideNavi">
      <div class="sideNavi-flex">
        <!-- <div class="sideNavi-item">
          <div
            class="flex justify-between !items-center bg-[#001c54] h-[70px] md:hidden"
          >
            <div class="w-full flex items-center justify-center p-2 gap-3">
              <img src="@/assets/home/phone.svg" alt="phone" class="w-4" />
              <a
                class="downbg !text-[15px] !font-semibold"
                href="tel:+918792974762"
                >Call</a
              >
            </div>
            <div
              class="border-r border-white border-solid border-2 h-14 w-2"
            ></div>
            <div class="w-full flex items-center justify-center p-2">
              <img src="@/assets/home/courses.png" alt="brochure" class="w-4" />
              <a
                class="downbg !text-[15px] !font-semibold mb-4"
                @click.prevent="openBrochurePopup"
              >
                Download Brochure
              </a>
            </div>
            <div
              v-if="whatsapp_status"
              class="border-r border-white border-solid border-2 h-14 w-2"
            ></div>
            <div
              v-if="whatsapp_status"
              class="w-full flex items-center justify-center p-2 gap-2"
            >
              <img
                src="@/assets/home/whatsapp-logo.svg"
                alt="whats-app"
                class="w-4"
              />
              <a
                class="downbg !text-[15px] !font-semibold"
                :href="whatsAppLink"
                target="_blank"
                >What's App</a
              >
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <BrochureView
      v-show="is_download_brochure"
      @close-button="is_download_brochure = false"
    /> -->
  </div>
</template>

<script>
import $ from "jquery";
// import BrochureView from "@/components/BrochureView.vue";
export default {
  // components: { BrochureView },
  data() {
    return {
      whatsAppLink: "",
      is_download_brochure: false,
      whatsapp_status: true,
    };
  },
  created() {
    const blockedPages = ["/lp/online-degree", "/lp/online-degree/"];
    this.whatsapp_status = !blockedPages.includes(this.$route.path);
  },
  mounted() {
    this.$nextTick(() => {
      const header = $("#header");
      if (header.length) {
        var stickyNavTop = header.offset().top + 500;
        var stickyNav = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > stickyNavTop) {
            header.addClass("sticky");
          } else {
            header.removeClass("sticky");
          }
        };
        stickyNav();

        $(window).scroll(function () {
          stickyNav();
        });
      }

      $('a[href^="#applyBox"]').on("click", function () {
        $("html, body").animate({ scrollTop: "0" });
      });

      $(document).scroll(function () {
        var y = $(this).scrollTop();
        if (y > 300) {
          $("#sideNavi").fadeIn();
        } else {
          $("#sideNavi").fadeOut();
        }
      });
    });
    // this.setWhatsAppLink();
  },
  // methods: {
  //   setWhatsAppLink() {
  //     const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  //     const baseWhatsAppURL =
  //       "https://api.whatsapp.com/send/?phone=+916364007160&app_absent=0";

  //     // Get the current route path
  //     const currentPath = this.$route.path;

  //     // Determine the message based on the current route
  //     let text = "";
  //     if (
  //       currentPath === "/lp/online-degree" ||
  //       currentPath === "/lp/online-degree/"
  //     ) {
  //       text =
  //         "Hello, can you provide details about your online degree programs?";
  //     } else if (
  //       currentPath === "/lp/online-mba" ||
  //       currentPath === "/lp/online-mba/"
  //     ) {
  //       text = "Hi, I am interested in knowing more about your MBA program";
  //     } else if (
  //       currentPath === "/lp/online-mca" ||
  //       currentPath === "/lp/online-mca/"
  //     ) {
  //       text = "Hello, I’d like to know more about your MCA program";
  //     } else if (
  //       currentPath === "/lp/online-bcom" ||
  //       currentPath === "/lp/online-bcom/"
  //     ) {
  //       text = "Hi, I’m looking for information on your B.Com course.";
  //     } else if (
  //       currentPath === "/lp/online-bba" ||
  //       currentPath === "/lp/online-bba/"
  //     ) {
  //       text = "Hello, I want to explore the BBA program at JAIN Online.";
  //     } else if (
  //       currentPath === "/lp/online-mcom" ||
  //       currentPath === "/lp/online-mcom/"
  //     ) {
  //       text = "Hi, I’d like more information about the M.Com course";
  //     } else {
  //       text = "Hi, I would like to know more about your programs";
  //     }
  //     this.whatsAppLink = `${baseWhatsAppURL}&text=${encodeURIComponent(text)}`;
  //   },
  //   handleClick(platform) {
  //     console.log(`User clicked on: ${platform}`);
  //   },
  //   openBrochurePopup() {
  //     this.is_download_brochure = true; // Open the BrochureView pop-up
  //   },
  // },
};

var ur3 = window.location.pathname;
function hashHandler() {
  window.history.replaceState({}, "", ur3);
}

window.addEventListener("hashchange", hashHandler, false);
</script>

<style></style>
